import { computed } from '@vue/composition-api'
import store from '@/store'

export default function useCalendarSidebar() {
  // ------------------------------------------------
  // calendarOptions
  // ------------------------------------------------
  const calendarOptions = computed(() => store.state.operationCalendar.calendarOptions)
  const calendarOptionsAll = computed(() => {
    const optionsArray = []
    if (calendarOptions.value && calendarOptions.value.length) {
      calendarOptions.value.forEach(a => {
        a.workFlows.forEach(i => {
          optionsArray.push(i._id)
        })
      })
    }

    return optionsArray
  })

  // ------------------------------------------------
  // selectedCalendars
  // ------------------------------------------------
  const selectedCalendars = computed({
    get: () => store.state.operationCalendar.selectedCalendars,
    set: val => {
      store.commit('operationCalendar/SET_SELECTED_EVENTS', val)
    },
  })

  // ------------------------------------------------
  // checkAll
  // ------------------------------------------------
  const checkAll = computed({
    /*
      GET: Return boolean `true` => if length of options matches length of selected filters => Length matches when all events are selected
      SET: If value is `true` => then add all available options in selected filters => Select All
           Else if => all filters are selected (by checking length of both array) => Empty Selected array  => Deselect All
    */
    get: () => selectedCalendars.value.length === calendarOptionsAll.value.length,
    set: val => {
      if (val) {
        selectedCalendars.value = calendarOptionsAll.value
      } else if (selectedCalendars.value.length === calendarOptionsAll.value.length) {
        selectedCalendars.value = []
      }
    },
  })

  return {
    calendarOptions,
    selectedCalendars,
    checkAll,
  }
}
